export default __webpack_public_path__ + "static/media/key5.deedee0c.png";